/*eslint-disable */

export default {
    "Tipo B": "https://storage.net-fs.com/hosting/6537235/36/",
    "Tipo C": "https://storage.net-fs.com/hosting/6537235/43/",
    "Tipo D": "https://storage.net-fs.com/hosting/6537235/43/",
    "Tipo A": "https://storage.net-fs.com/hosting/6537235/45/",
}